import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';


@Pipe({name: 'formatDate'})
export class FormatDate implements PipeTransform {
  transform(date: string, format: string): string {
    return moment(date).locale("es-ES").format(format);
  }
}

@Pipe({name: 'beginDate'})
export class BeginDate implements PipeTransform {
  transform(date: string, format: string): string {
    return moment(date, format).format("YYYY-MM-DD");
  }
}

@Pipe({name: 'endDate'})
export class EndDate implements PipeTransform {
  transform(date: string, format: string): string {
    return moment(date, format).format("YYYY-MM-DD") + "T23:59:59";
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/pipes/format-date.pipe.ts